import React from 'react';
import { useScheduleDesviationForm } from '../../../hooks/scheduleDesviation/useScheduleDesviationForm';
import { useTranslation } from 'react-i18next';
import { Checkbox, FormControlLabel, FormHelperText, Grid, InputAdornment, TextField } from '@mui/material';
import { nameValidation } from 'utils/Validations';

interface Props {
    form: ReturnType<typeof useScheduleDesviationForm>;
    mode: 'add' | 'edit' | 'delete' | 'info' | 'duplicate';
}

export const ScheduleDesviationForm = ({ form, mode }: Props) => {
    const { t } = useTranslation();
    const { existName, form: formState } = form;

    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ mt: 1.5 }}>
                <TextField
                    id={'input-name'}
                    fullWidth
                    label={t('settings.schedule_desviation.table.dialog.add.name')}
                    value={formState.name}
                    autoComplete="off"
                    onChange={(e) => {
                        const newName = e.target.value;
                        if (nameValidation(newName)) {
                            form.update('name', newName);
                            existName(newName);
                        }
                    }}
                    required
                    error={mode !== 'info' && existName(formState.name)}
                    slotProps={{
                        htmlInput: { maxLength: 100 },
                        input: {
                            endAdornment: <InputAdornment position="end">{`${formState.name.length}/100`}</InputAdornment>,
                        },
                    }}
                    disabled={mode === 'info'}
                />
                <FormHelperText
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mt: 0.5,
                        px: 1.75,
                    }}
                >
                    <span>{mode !== 'info' && existName(formState.name) ? t('settings.schedule_desviation.table.dialog.add.exist_name') : ''}</span>
                </FormHelperText>
            </Grid>
            <Grid size={6} sx={{ mt: 1.5 }}>
                <div>
                    <FormControlLabel
                        control={<Checkbox checked={formState.before_shift} onChange={(e) => form.update('before_shift', e.target.checked)} slotProps={{ input: { 'aria-label': 'controlled' } }} />}
                        label={t('settings.schedule_desviation.table.columns.before_shift')}
                        disabled={mode === 'info'}
                    ></FormControlLabel>
                </div>
            </Grid>
            <Grid size={6} sx={{ mt: 1.5 }}>
                <div>
                    <FormControlLabel
                        control={<Checkbox checked={formState.after_shift} onChange={(e) => form.update('after_shift', e.target.checked)} slotProps={{ input: { 'aria-label': 'controlled' } }} />}
                        label={t('settings.schedule_desviation.table.columns.after_shift')}
                        labelPlacement="end"
                        disabled={mode === 'info'}
                    ></FormControlLabel>
                </div>
            </Grid>
            <Grid size={6} sx={{ mt: 1.5 }}>
                <div>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={formState.requires_approval}
                                onChange={(e) => form.update('requires_approval', e.target.checked)}
                                slotProps={{ input: { 'aria-label': 'controlled' } }}
                            />
                        }
                        disabled={mode === 'info'}
                        label={t('settings.schedule_desviation.table.columns.requires_approval')}
                    ></FormControlLabel>
                </div>
            </Grid>
            <Grid size={6} sx={{ mt: 1.5 }}>
                <div>
                    <FormControlLabel
                        control={<Checkbox checked={formState.unplanned} onChange={(e) => form.update('unplanned', e.target.checked)} slotProps={{ input: { 'aria-label': 'controlled' } }} />}
                        label={t('settings.schedule_desviation.table.columns.unplanned')}
                        labelPlacement="end"
                        disabled={mode === 'info'}
                    ></FormControlLabel>
                </div>
            </Grid>
            <Grid size={12} sx={{ mt: 1 }}>
                <TextField
                    id="filled-textarea"
                    placeholder={t('settings.schedule_desviation.table.dialog.add.max_description')}
                    fullWidth
                    label={t('settings.schedule_desviation.table.dialog.add.description')}
                    value={formState.description}
                    autoComplete="off"
                    multiline
                    rows={4}
                    slotProps={{
                        htmlInput: { maxLength: 255 },
                        input: {
                            endAdornment: <InputAdornment position="end">{`${formState.description.length}/255`}</InputAdornment>,
                        },
                    }}
                    onChange={(e) => form.update('description', e.target.value)}
                    disabled={mode === 'info'}
                />
            </Grid>
        </Grid>
    );
};
